import CommonUiModel from "../common/commonUiModel";

const ScopeSearchModel = new CommonUiModel({
    title: "SearchScope",
    customAddText: "Add",
    gridTitle: 'Search Scope',
    showHistory: false,
    formTile: 'Search Scope',
    idProperty: 'ScopeModelId',
    permissions: { add: true, edit: false, delete: false },
    navigateBack: true,
    module: "ScopeMaster",
    selectionApi: "EquipmentScope",
    breadcrumbColor: '#efc630',
    enableGoBack: true,
    selectionUpdateKeys: ["RevisionId", "ScopeModelId", "EquipmentId", "SoldIn", "ScopeModel"],
    columns: [
        { label: '', field: 'selection Box', type: 'selection', width: 100, sortable: false, filterable: false, exportable: false },
        { field: 'ScopeModel', label: 'Scope Model', required: true },
        { label: 'Scope Type', field: 'ScopeType', width: 150, type: "string", required: true },
        { label: 'Manufacturer', field: 'Manufacturers', width: 150, type: 'string', required: true },
        { field: 'Channels', label: 'Channels', type: 'number', width: 100, min: 0, max: 7, hide: true },
        { field: 'Series', label: 'Series', type: 'string', width: 150, required: true },
        { field: 'SoldIn', label: 'Sold In', type: 'select', width: 150, required: true, lookup: 'SoldInRegion', hide: true },
        { field: 'WorkingLength', label: 'Working Length(mm)', type: 'string', required: true, width: 150, minValue: 0, hide: true },
        { field: 'RepresentativeScope', label: 'Rep Scope', type: 'string', width: 150, hide: true },
        { field: 'StatusId', label: 'Status', type: 'select', width: 150, lookup: 'ScopeStatus', required: true, hide: true },
        { field: 'Notes', label: 'Notes', multiline: true, min: 3, hide: true },
        { field: "ScopeModelAlias", label: "Alias", type: "chipInput", required: false, lookup: 'scopeModelAlias', width: 300 }
    ]
});
export default ScopeSearchModel;